import { gql } from "@apollo/client";
import { DetailHeroFragment } from "./DetailHero";
import { PageDataFragment } from "./PageData";

export const ExhibitTypeFragment = gql`
  fragment ExhibitType on Exhibit {
    exhibitTypes {
      nodes {
        slug
        name
      }
    }
  }
`;

export const ExhibitFragment = gql`
  ${ExhibitTypeFragment}
  fragment ExhibitFragment on Exhibit {
    title
    uri
    ...ExhibitType
    exhibitData {
      cardTitle
      excerpt
      ticketLink
      customCursorText
      exhibitType {
        id
        slug
      }
      exhibitMedia {
        mediaType
        image {
          ...ACFMedia
        }
        videoUrl
        videoThumbnail {
          ...ACFMedia
        }
      }
    }
  }
`;

export const ExhibitDetailFragment = gql`
  ${ExhibitFragment}
  ${DetailHeroFragment}
  ${ExhibitTypeFragment}
  ${PageDataFragment}
  fragment ExhibitDetailFragment on Exhibit {
    ...ExhibitType
    ...PageData
    ...ExhibitFragment
    detailHero {
      ...DetailHero
    }
  }
`;
